<script>
  import { onMount, createEventDispatcher, afterUpdate } from "svelte";
  import Select from "../HTMLElements/Select.svelte";
  import { Child, ChildChunks, HelpSummary, CurrentSchoolBoroughs, DefaultChildChunks } from "./store.js";
  import * as objectWrapper from "../Utils/ObjectWrapper.js";
  import * as Validator from "../Utils/ValidateFormFIelds.js";
  import Field from "../FormField.svelte";
  import Radio from "../HTMLElements/RadioInput.svelte";
  import TextBox from "../HTMLElements/Textbox.svelte";
  import { GetChild } from "./service.js";
  import SearchSelect from "../HTMLElements/SearchSelect.svelte";
  import wrappedFetch from "../../wrappedFetch.js";
  
  const dispatch = new createEventDispatcher();

  let wrappedObj;
  let laList=[];
  let availableSchools = [];
  let isFormValid = true;
  let error = ''
  let ref = null;
  let showSchoolsList = true;
  let schoolText="school";
  let schoolTextPlural = "schools";
  
  let radioItems = [];   
  let radioCurrentSchool = { value: "", isDirty: false, isValid: false };
  export let radioParams1 = {};
  export let radioParams = {};
  export let isSibling = false;
  export let id;
  export let applicationId;
  export let applications =[];
  export let lateApplications =[];

  let showApplicationResubmit =false;
  let isDetailsChanged = false;
  let isSaveAndExit = false;
  let gender;
  let phaseID;

  const getHelpText = title => {
    if ($HelpSummary.length > 1)
      return $HelpSummary.find(h => h.title === title).text;
  };

  const handleSchoolChange =()=>{
if(wrappedObj.currentSchoolId.value == 0)
    wrappedObj.schoolNotFound.value = true;
  }

  const populateBoroughs = async () => {
    if ( $CurrentSchoolBoroughs.length <= 0 ) {
      // include LAs where the only schools are closed or private, eg City of London. 
      await wrappedFetch(`borough/GetAvailBoroughsForCurrent?phase=${$Child.phaseId}&gender=${$Child.gender}`)
        .then(res => res.json())
        .then(result => {
          laList = result;
          laList.forEach((data, key) => {
            laList[key]["label"] = data.name;
          });
          CurrentSchoolBoroughs.set(laList);
        });
    }
  }
  const selectSchools = async () => {
    availableSchools = await wrappedFetch(
      "child/GetAvailableSchools?laid=" +
        wrappedObj.currentSchoolLaid.value +
        "&childId=" +
        id
    ).then(result => result.json());
   
      availableSchools.forEach((data,key) => {availableSchools[key]["label"] = data.name;})    
      availableSchools.push({id:0,label:`${schoolText.charAt(0).toUpperCase()
																						+ schoolText.slice(1)} not listed?`,name:`${schoolText.charAt(0).toUpperCase()
																						+ schoolText.slice(1)} not listed?`})    
    if( availableSchools.findIndex(x => x.id == wrappedObj.currentSchoolId.value) == -1)
      wrappedObj.currentSchoolId.isValid = false;  
  };

  const handleLaChange = async()=>{
    wrappedObj.currentSchoolId.value = null;
    availableSchools =[];
   await selectSchools();
      dispatch("laChange");
  }

  $: {
      if(wrappedObj ){      
        if( radioCurrentSchool.value == "atSchool" && !wrappedObj.schoolNotFound.value) { 
          if ( wrappedObj.currentSchoolLaid.isDirty && ( !wrappedObj.currentSchoolLaid.value || wrappedObj.currentSchoolLaid.value == '' ))
            wrappedObj.currentSchoolLaid.isValid = false;
          else  {
            if ( !wrappedObj.currentSchoolId.value || wrappedObj.currentSchoolId.value == '') 
              wrappedObj.currentSchoolId.isValid = false;
          }
        } else {
          wrappedObj.currentSchoolLaid.isValid = true;
          wrappedObj.currentSchoolId.isValid = true;
        }

        if( !wrappedObj.schoolNotFound.value)
          wrappedObj.currentSchoolNameTyped.isValid = true;

        if(wrappedObj.currentSchoolNameTyped.value == '' && radioCurrentSchool.value != 'atSchool' )
          wrappedObj.schoolNotFound.value = false;
      }
     
   }

  afterUpdate(() => {
    dispatch('changed')
  });
  
  onMount(async () => {

    if (!$Child || !id) await GetChild(id);

    if($Child.phase =="N1") dispatch('pageChange', `/application/relationdetails/${id}/${applicationId}`);
    if($Child.phase=="P") {schoolText="nursery"; schoolTextPlural = "nurseries"} else {schoolText = 'school'; schoolTextPlural = "schools"}
      radioItems = [   
    { value: "notAtSchool", TextValue: `Not currently attending ${schoolText}`,disable:isSibling},
    { value: "homeEducated", TextValue: "Educated at home" ,disable:isSibling},
    { value: "abroadEducated", TextValue: "Educated abroad",disable:isSibling }
  ];
  radioParams1 = { item:  [{ value: "atSchool", TextValue: `Attending a ${schoolText}` ,disable:isSibling}], required: true, label: 'school status' };
  radioParams= { item: radioItems, required: true, label: 'school status' };
    if(!$Child.multipleBirth)
       dispatch('pageChange', `/application/childattributes/${id}/${applicationId}`);
    
    ChildChunks.set({
      currentSchool: {
        id:$Child.id,
        currentSchoolId: $Child.currentSchoolId,
        currentSchoolLaid: $Child.currentSchoolLaid,
        currentSchoolName: $Child.currentSchoolName,
        currentSchoolNameTyped: $Child.currentSchoolNameTyped,
        schoolNotFound: $Child.schoolNotFound,
        notAtSchool: $Child.notAtSchool,
        homeEducated: $Child.homeEducated,
        abroadEducated: $Child.abroadEducated
      }
    });
    DefaultChildChunks.set($ChildChunks)
    await populateBoroughs();    
    wrappedObj = objectWrapper.wrapObject($ChildChunks.currentSchool);

    if( wrappedObj.notAtSchool.value)
      radioCurrentSchool.value = "notAtSchool";
    else if( wrappedObj.homeEducated.value)
      radioCurrentSchool.value = "homeEducated";
    else if( wrappedObj.abroadEducated.value )
      radioCurrentSchool.value = "abroadEducated";
		else if( wrappedObj.currentSchoolId.value || wrappedObj.currentSchoolNameTyped.value)
      radioCurrentSchool.value = "atSchool";
    
    if(radioCurrentSchool.value == 'atSchool')
      selectSchools(); // for initial selection
  });

  async function saveChild() {
    const saveChildURL = "child/savechildcurrentschooldetails"; 
    const resp = await wrappedFetch(saveChildURL, {
      method: "post",
      body: JSON.stringify($ChildChunks.currentSchool),
      headers: {
        "Content-Type": "application/json"
      }
    });

    return await resp.json();
  }

  const validateAndSave = async () => {
    isFormValid = true;   

    if( !radioCurrentSchool.value || radioCurrentSchool.value == '' ){       
      isFormValid = false;
      radioCurrentSchool.isValid = false;
      radioCurrentSchool.isDirty = true;
      error = "Please ensure that you have completed the required fields.";
      return;
    }

    if (!Validator.validate(wrappedObj)) {      
      isFormValid = false;
      error = "Please ensure that you have completed the required fields.";
      wrappedObj = wrappedObj;
      return;
    }


    wrappedObj.notAtSchool.value = radioCurrentSchool.value == "notAtSchool" ? "Y" : "N";
    wrappedObj.homeEducated.value = radioCurrentSchool.value == "homeEducated" ? "Y" : "N";
    wrappedObj.abroadEducated.value = radioCurrentSchool.value == "abroadEducated" ? "Y" : "N";

    if(radioCurrentSchool.value == 'atSchool'){
      if (wrappedObj.schoolNotFound.value) {
        wrappedObj.currentSchoolId.value = null;
        wrappedObj.currentSchoolName.value = '';
      } else{
        wrappedObj.currentSchoolNameTyped.value = '';
      }
    } else {
      wrappedObj.schoolNotFound.value = "N";
      wrappedObj.currentSchoolId.value = null;
      wrappedObj.currentSchoolName.value = '';
      wrappedObj.currentSchoolNameTyped.value = '';
    }


    
    ChildChunks.set({ currentSchool: objectWrapper.unwrapObject(wrappedObj)});
$DefaultChildChunks.currentSchool.currentSchoolName = $DefaultChildChunks.currentSchool.currentSchoolName == null ?"":$DefaultChildChunks.currentSchool.currentSchoolName;
     //Check if anything changed before doing anything else 
isDetailsChanged = !(JSON.stringify($ChildChunks) === JSON.stringify($DefaultChildChunks));


       if(!isDetailsChanged)
       {
         if(isSaveAndExit)
         dispatch("pageChange", '/user/home');
         else
         dispatch("pageChange", `/application/relationdetails/${id}/${applicationId}`);            
          return;
       }

   let childResp = await saveChild();   
    if (childResp.success) {
      Child.set(childResp.child); 
       applications=childResp.applications || [];
      lateApplications = childResp.lateApplications || [];    
      //dispatch("notification","Details changed successfully!!");
      if(applications.length > 0 || lateApplications.length > 0)
      {        
        if(!$Child.isSibling){
          showApplicationResubmit = true;     
          dispatch('showApplicationResubmitModal',isSaveAndExit ?'/user/home' :`/application/relationdetails/${id}/${applicationId}`);
        }
      }   
      //dispatch("pageChange", `/application/secondcontact/${$Child.id}`);
    }
  };

  const saveAndNavigate = async () => {
    await validateAndSave();
    if (isFormValid && !showApplicationResubmit) dispatch("pageChange", `/application/relationdetails/${id}/${applicationId}`);
  }

  export const saveAndExit = async () => {
    isSaveAndExit = true;
    await validateAndSave();
    if (isFormValid && !showApplicationResubmit) { dispatch("pageChange", '/user/home');}
  }
</script>

<div class="step-3-shows">
  <div class="field">
    <a href="#" on:click|preventDefault={()=> {dispatch('back', `/application/childattributes/${id}/${applicationId}`)}}>
      <span class="fas fa-arrow-left" />
      Back
    </a>
  </div>
  <div style="display:inline-flex" >
  <h1 class="title is-3">Current {schoolText}</h1>
  </div>

  {#if wrappedObj}
  <Field   
    helpId="help25"
  label=" Is your child currently attending a {schoolText}? (Private {schoolTextPlural} are included for most Local Authorities)"
    showInfo={!radioCurrentSchool.isValid && radioCurrentSchool.isDirty }
  />
  <Radio
    bind:group={radioCurrentSchool.value}
    label="current {schoolText}"
    {...radioParams1}
    isFlex={true} />
  
  {#if radioCurrentSchool.value == 'atSchool' && !wrappedObj.schoolNotFound.value}
    <div id="schoolDetails" style="padding:0.5rem;">
          
        <Field
          label="Where is the {schoolText} located? - Use the dropdown box to change the Local Authority">
          <span slot="inputField">          
              <Select
                items={$CurrentSchoolBoroughs}
                bind:selectedValue={wrappedObj.currentSchoolLaid.value}
                placeholder="--- Please select ---"
                isRequired="true"
                selectedValueText="id"
                bind:isValid={wrappedObj.currentSchoolLaid.isValid}
                bind:isDirty={wrappedObj.currentSchoolLaid.isDirty}
                on:change={handleLaChange}                
                label="a Local Authority"
                disabled={isSibling} />
          </span>      
       
        </Field>
        {#if wrappedObj.currentSchoolLaid.value != null && wrappedObj.currentSchoolLaid.value != '' && availableSchools.length > 0}
          <Field label="Name of {schoolText}">
            <span slot="inputField">
              <SearchSelect
                itemList={availableSchools}
                placeholder="--- Please select a {schoolText} ---"
                disabled={isSibling}  
                bind:selected={wrappedObj.currentSchoolId.value}
                bind:isValid={wrappedObj.currentSchoolId.isValid}
                bind:isDirty={wrappedObj.currentSchoolId.isDirty}
                on:change={handleSchoolChange} 
                bind:showDropdown={showSchoolsList} 
                showSchoolNotListed={true}/>
            </span>
          </Field>
         {/if}
    </div>    
  {/if}
      <Radio
      label="current {schoolText}"
        bind:group={radioCurrentSchool.value}
        {...radioParams}
        isFlex={true} />
         {#if radioCurrentSchool.value == 'atSchool' && !isSibling}
    {#if wrappedObj.schoolNotFound.value}
      <Field label="Enter your child's current {schoolText}">
        <!-- info={getHelpText('Help25')}
        helpId="help25"> -->
        <span slot="inputField">
            <TextBox
            placeholder="Enter {schoolText} name"
            isRequired={wrappedObj.schoolNotFound.value ? "true":"false"}
            bind:text={wrappedObj.currentSchoolNameTyped.value}
            bind:isValid={wrappedObj.currentSchoolNameTyped.isValid}
            bind:isDirty={wrappedObj.currentSchoolNameTyped.isDirty}
            label="current school" />
        </span>
      </Field>
      <a href="#" on:click|preventDefault={()=>{wrappedObj.schoolNotFound.value = false;}}>Return to {schoolText} selection</a>
    {/if}
  {/if}
  <hr />
  {#if !isFormValid}
    <div class="notification is-invalid">
      <p>{error}</p>
    </div>
  {/if}
  <div>
    <button class="button is-primary" on:click={saveAndNavigate}>
      Save and continue
    </button>
  </div>
  {/if}
</div>
